import React from 'react';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { showCandidateProfilePreviewModal } from '../../../features/popup/offcanvasSlice';
import CandidateProfileReadOnly from '../CandidateProfileReadOnly';

const CandidateProfilePreviewModal = ({
    candidateProfilePreviewModalVisible,
    candidateID,
    showCandidateProfilePreviewModal
}) => {
    return (
        <div>
            <Modal show={candidateProfilePreviewModalVisible} size="xl" centered backdrop="static" onHide={() => {showCandidateProfilePreviewModal({candidateProfilePreviewModalVisible: false, candidateID: null})}}>
                <Modal.Body>
                    <div class="d-flex justify-content-between align-items-center mb-2">
                        <h3 class="mb-0 fs-5 d-flex align-items-center">
                            {/* <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="#2563EB" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-badge-check"><path d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z" /><path d="m9 12 2 2 4-4" /></svg>
                            <span class="ms-1">Get Verified {candidateID}</span> */}
                        </h3>
                        <span class="fs-3 cursor-pointer" onClick={() => {showCandidateProfilePreviewModal({candidateProfilePreviewModalVisible: false, hrReviewCandidateID: null})}}><ion-icon name="close-outline"></ion-icon></span>
                    </div>
                    {/* <div class="p-2 mb-2" style={{ background: '#FEF6D8', borderRadius: '5px' }}>
                        <h4 class="fw-bold">How verification works?</h4>
                        <div class='w-100 d-flex justify-content-between mt-4'>
                            <div class="d-flex flex-column align-items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#45a994" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-calendar-fold"><path d="M8 2v4" /><path d="M16 2v4" /><path d="M21 17V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h11Z" /><path d="M3 10h18" /><path d="M15 22v-4a2 2 0 0 1 2-2h4" /></svg>
                                <h5 class="text-black text-center mt-1">Book a call with ScopeHai HR</h5>
                            </div>
                            <div class="d-flex align-items-center" style={{ marginBottom: '30px' }}>
                                <IoMdRedo size={30} />
                            </div>
                            <div class="d-flex flex-column align-items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#45a994" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-laptop"><path d="M20 16V7a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v9m16 0H4m16 0 1.28 2.55a1 1 0 0 1-.9 1.45H3.62a1 1 0 0 1-.9-1.45L4 16" /></svg>
                                <h5 class="text-black text-center mt-1">Initial screening and interview</h5>
                            </div>
                            <div class="d-flex align-items-center" style={{ marginBottom: '30px' }}>
                                <IoMdRedo size={30} />
                            </div>
                            <div class="d-flex flex-column align-items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#45a994" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-badge-check"><path d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z" /><path d="m9 12 2 2 4-4" /></svg>
                                <h5 class="text-black text-center mt-1">Verification done, increased visibility!</h5>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex justify-content-end allign-items-center">
                        <button class="btn btn-primary">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-badge-check"><path d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z" /><path d="m9 12 2 2 4-4" /></svg>&nbsp;
                            Apply for Verification
                        </button>
                    </div> */}
                    <CandidateProfileReadOnly />
                </Modal.Body>
            </Modal>
        </div>
    );
};

const mapStateToProps = ({ offcanvas }) => {
    const {
        candidateProfilePreviewModalVisible,
        candidateID
    } = offcanvas
    return {
        candidateProfilePreviewModalVisible,
        candidateID
    }
}

const mapDispatchToProps = {
    showCandidateProfilePreviewModal
}

export default connect(mapStateToProps, mapDispatchToProps)(CandidateProfilePreviewModal);